export const whiskeyAttributesMapping = {
  price: 'Price',
  name: 'Name',
  description: 'Description',
  type: 'Type',
  nose: 'Nose',
  palate: 'Palate',
  finish: 'Finish',
  flight: 'Flight',
};

export const barrelItemAttributesMapping = {
  name: 'Name',
  pour: 'Pour',
  bottle: 'Bottle',
}

export const flightAttributesMapping = {
    flight: 'Flight',
    name: 'Name',
    price: 'Price',
}

export const specialsAttributeMapping = {
  item: 'Item',
  text: 'Text',
  text1: 'Text1',
  text2: 'Text2',
  text3: 'Text3',
  text4: 'Text4',
  text5: 'Text5',
}

export interface SpecialsItem {
    item: string | undefined;
    text: string | undefined;
    text1: string | undefined;
    text2: string | undefined;
    text3: string | undefined;
    text4: string | undefined;
    text5: string | undefined;
}

export interface WhiskeyItem {
    price: number | undefined;
    name: string | undefined;
    description: string | undefined;
    type?: string | undefined;
    nose?: string | undefined;
    palate?: string | undefined;
    finish?: string | undefined;
    flight?: string | undefined;
}

export interface BarrelItem {
    name: string | undefined;
    pour: number | undefined;
    bottle: string | undefined;
}

export interface Flight {
    flight: string | undefined;
    name: string | undefined;
    price: number | undefined;
}

export enum SheetNames {
    FLIGHTS = 'Flights',
    RESERVE = 'Reserve',
    BOURBON = 'Bourbon',
    IRISH = 'Irish',
    SCOTCH = 'Scotch',
    JAPANESE = 'Japanese',
    RYE = 'Rye',
    AMERICAN = 'American',
    OTHER = 'Other',
    SPECIALS = 'Specials',
    DRINKS_FOR_A_CAUSE = 'Drink For a Cause',
    BARREL_PICKS = 'Barrel Pick',
    VERTICAL_FLIGHTS = 'Vertical Flights'
}
